import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggingService } from './logging.service';
import { UserNotificationService } from './user-notification.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
export const ADJUSTMENTBALANCEDATA_URL = '/api/adjustmentsTestedPartyBalanceData';
import { saveAs } from 'file-saver-es';
import { BalanceDataInterestRate } from '../mystudies/analysis/adjustments/tested-party/balance-sheet/interest-rate/interest-rate.model';
import { Header } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class InterestRateService {
  public uiBlocked$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public isImportCompleted: EventEmitter<boolean> = new EventEmitter();

  constructor(private http: HttpClient, private logger: LoggingService, private userNotificationService: UserNotificationService) {}

  public getBalanceDataInterestRate(adjustmentsTestedPartyBalanceDataId: number): Observable<BalanceDataInterestRate> {
    const url = `${ADJUSTMENTBALANCEDATA_URL}/GetBalanceDataInterestRate/${adjustmentsTestedPartyBalanceDataId}`;
    return this.http.get<BalanceDataInterestRate>(url).pipe(
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }

  // public getInterestRateFileSize(interestRateSourceDocPath: string, adjustmentsTestedPartyBalanceDataId: number): Observable<any>{
  //   const url =`${ADJUSTMENTBALANCEDATA_URL}/GetInterestRateFileSize`;

  //   const body = {
  //     'AdjustmentsTestedPartyBalanceDataId': adjustmentsTestedPartyBalanceDataId,
  //     'InterestRateSourceDocPath': interestRateSourceDocPath
  //                 };
  //   return  this.http.post(url, body).pipe(
  //     map(res => {
  //       if (res) {
  //         if(res=="Blob doesn't exist")
  //         return "";
  //         else
  //         return res;
  //       }}),
  //     catchError(error => {
  //       this.logger.httpError(this.constructor.name, url, error);
  //       return throwError(()=>error);
  //     }));
  // }
  public getInterestRateFileSize(formdata: FormData): Observable<any> {
    const url = `${ADJUSTMENTBALANCEDATA_URL}/GetInterestRateFileSize`;
    const httpOptions = {
      headers: new HttpHeaders({
        //  'Content-Type': '',
        Accept: '*/*',
      }),
    };
    return this.http.post(url, formdata, httpOptions).pipe(
      map((res) => {
        if (res) {
          if (res == "Blob doesn't exist") return '';
          else return res;
        }
        return '';
      }),
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }
  public getBalanceDataInterestRateFileList(testedPartyId: number): Observable<any> {
    const url = `${ADJUSTMENTBALANCEDATA_URL}/GetBalanceDataInterestRateFileList/${testedPartyId}`;
    return this.http.get<any>(url).pipe(
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }
  public deleteInterestRateFileOrSource(formdata: FormData, returnurl: string, adjustmentsTestedPartyBalanceDataId: number): Observable<any> {
    const url = `${ADJUSTMENTBALANCEDATA_URL}/${adjustmentsTestedPartyBalanceDataId}/DeleteInterestRateFileOrSource`;

    const httpOptions = {
      headers: new HttpHeaders({
        //  'Content-Type': '',
        Accept: '*/*',
      }),
    };

    return this.http.post(url, formdata, httpOptions).pipe(
      map((res) => {
        if (res) {
          this.userNotificationService.addNotification(
            `Interest data delete successfully for AdjustmentsTestedPartyBalanceDataId ${adjustmentsTestedPartyBalanceDataId}.`,
            false
          );
        }
        return res;
      }),
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }

  public uploadInterestRateFile(
    formdata: FormData,
    returnurl: string,
    adjustmentsTestedPartyBalanceDataId: number,
    files: Array<any>
  ): Observable<any> {
    const url = `${ADJUSTMENTBALANCEDATA_URL}/${adjustmentsTestedPartyBalanceDataId}/UploadInterestRateFile`;
    const interestRateBlobStoragePath = formdata.get('interestRateBlobStoragePath');
    let fileName;
    for (let j = 0; j < files.length; j++) {
      fileName = formdata.get('file[]');
    }
    const httpOptions = {
      headers: new HttpHeaders({
        //  'Content-Type': '',
        Accept: '*/*',
      }),
    };

    return this.http.post(url, formdata, httpOptions).pipe(
      map((res) => {
        if (res) {
          if (fileName) {
            this.userNotificationService.addNotification(
              `Interest file ${fileName.name} uploaded successfully for AdjustmentsTestedPartyBalanceDataId ${adjustmentsTestedPartyBalanceDataId}.`,
              false
            );
          } else if (interestRateBlobStoragePath) {
            this.userNotificationService.addNotification(
              `Interest file ${interestRateBlobStoragePath} uploaded successfully for AdjustmentsTestedPartyBalanceDataId ${adjustmentsTestedPartyBalanceDataId}.`,
              false
            );
          }
        }
        return res;
      }),
      catchError((error) => {
        this.logger.httpError(this.constructor.name, url, error);
        return throwError(() => error);
      })
    );
  }

  public downloadInterestRateFile(formdata: FormData, returnurl: string, interestRateSourceDocPath: string): Observable<any> {
    this.logger.info(this.constructor.name, 'DownloadInterestRateFile', 'Start');
    const url = `${ADJUSTMENTBALANCEDATA_URL}/DownloadInterestRateFile`;

    let filenamepath: string[];
    let filename = '';
    if (interestRateSourceDocPath != null) {
      filenamepath = interestRateSourceDocPath.split('/');
      filename = filenamepath[filenamepath.length - 1];
    }
    const httpOptions = {
      headers: new HttpHeaders({
        //  'Content-Type': '',
        Accept: '*/*',
      }),
      responseType: 'blob' as 'blob',
    };

    return this.http.post(url, formdata, httpOptions).pipe(
      map((result) => {
        if (result.type != 'text/plain') {
          const blob = new Blob([result]);
          // const saveAs = require('file-saver-es');
          const file = filename;
          saveAs(blob, file);
        } else {
          alert('File not found in Blob!');
        }
      })
    );
  }

  blockUI() {
    this.uiBlocked$.next(true);
  }

  unblockUI() {
    this.uiBlocked$.next(false);
  }
}
